// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1Msky","info":"UpdateTermsInfo_info__3g7WF"};